export default __webpack_public_path__ + "static/media/refresher.4a07cf55.svg";